import PracticePageV2 from "@/components/site/v2/PracticePageV2";
import { INTELLIGENCE_PAGE as page } from "@/data/intelligencePage";
import { INTELLIGENCE_SUBPAGES } from "@/data/intelligenceSubPages";

const CAP_URL = "/capabilities/market-customer-intelligence";

export default function IntelligencePage() {
  const explorerItems = page.offers.map((o, i) => ({
    name: o.name,
    outcome: o.lead,
    body: o.body,
    covers: o.list,
    link: INTELLIGENCE_SUBPAGES[i]
      ? {
          to: `${CAP_URL}/${INTELLIGENCE_SUBPAGES[i].slug}`,
          label: `Explore ${o.name}`,
        }
      : undefined,
  }));

  return (
    <PracticePageV2
      testid="intelligence-page"
      page={page}
      capUrl={CAP_URL}
      image="/photos/practice-hero-intelligence.jpg"
      imageAlt="Indian market researcher interviewing a shopper with a tablet in a bright retail aisle"
      heroDescription="Understand markets, customers and competitors — identify opportunities, reduce uncertainty and make stronger commercial decisions."
      heroTagline="Better decisions start with better intelligence."
      challenges={page.introQuestions.map((q) => ({ title: q, to: "#capabilities" }))}
      explorerItems={explorerItems}
      deliverables={page.deliver}
      frameworkHeadline={page.approachLead}
      methods={page.methods}
    />
  );
}
